import { Button, Modal } from '@cimpress/react-components';
import React from 'react';

interface Props {
    showModal: boolean;
    onConfirm: (confirmed: boolean) => void;
    children: React.ReactNode;
    title?: string;
    status?: 'success' | 'info' | 'danger' | 'warning';
}

function ConfirmModal({ showModal, onConfirm, children, title = 'Are you sure?', status = 'info' }: Props) {
    return (
        <Modal className='confirm-modal-scene-maker' show={showModal} title={title}>
            <div className='confirm-modal-scene-maker__body'>{children}</div>
            <div className='confirm-modal-scene-maker__footer'>
                <Button variant='primary' className={`btn-${status}`} onClick={() => onConfirm(true)}>
                    Continue
                </Button>
                <Button onClick={() => onConfirm(false)}>Cancel</Button>
            </div>
        </Modal>
    );
}

export default ConfirmModal;
